module.exports = __webpack_public_path__ + "static/media/bg15.e1254d02.jpg";